import { createRootRoute, Outlet } from "@tanstack/react-router"
import { useEffect } from "react"
import styles from "./__root.module.scss"

function RootComponent() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ref = params.get("ref")

    if (ref) {
      localStorage.setItem("referralCode", ref)
      document.cookie = `referralCode=${ref}; path=/; max-age=${60 * 60 * 24 * 30}` // 30 days 
    }
  }, [])

  return (
    <div className={styles.root}>
      <Outlet />
    </div>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})
